import compactLogo from '../assets/logo-compact-transparent.png';
import {navigate} from '../lib/navigation';

export const Brand = () => (
  <button aria-label="UFAT home" className="inline-flex cursor-pointer items-center border-0 bg-transparent p-0 text-left" onClick={() => navigate('/')} type="button">
    <img className="nx-brand-logo h-11 w-11 object-contain transition-[filter] duration-200" src={compactLogo} alt="" />
  </button>
);
